import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import dayjs from "dayjs";
import "dayjs/locale/fr";
import App from "./App";
import "./index.css";

// Pendant obligatoire du `locale={frFR}` d'antd : les noms de mois et de jours
// viennent de dayjs, pas d'antd. Sans cette ligne, un « MMM » rend « Jul » au
// milieu d'une interface française, et les calendriers restent en anglais.
dayjs.locale("fr");

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
